import { create } from "zustand";

export const useGlobalStore = create((set) => ({
  search: "",
  setsearch: (key) => set({ search: key }),
}));
